export default __webpack_public_path__ + "static/media/work-3right-2.524f0da2.png";